<div>
  @if (title(); as title) {
    <p class="title caption-md">{{ title }}</p>
  }
  <p class="message body-md">{{ message() }}</p>
</div>

<smw-icon [icon]="closeIcon" (click)="close()" />
